import GLApi from './_glApi';
import httpClient from '@/apis/base/httpclient';
class GLVoucherAPI extends GLApi {
  constructor() {
    super();
  }
  controllerName = 'GLVouchers';

  /**
   * API lấy số thặng dư
   * nthien4 10.09.2022
   */
  getTotalAmountPre(fromDate, toDate) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/getTotalAmountPre',
      data: { fromDate, toDate },
    };
    return this.getAsync(request);
  }

  /**
   * API kiểm tra đã phát sinh quyết toán thuế trong năm hay chưa
   * nthien4 11.09.2022
   */
  checkIncurredTaxByYear(year, refType, period) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/checkIncurredTaxByYear',
      data: { year, refType, period },
    };
    return this.getAsync(request);
  }

  /**
   * API lấy số thuế TNDN tạm tính trong năm
   * nthien4 11.09.2022
   */
  getAmountFinalTaxIncome(years) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/getAmountFinalTaxIncome',
      data: { years },
    };
    return this.getAsync(request);
  }

  // Xóa nhiều
  async customDelete(payload) {
    let request = {
      url: this.getAPIUrl() + '/CustomDelete',
      data: payload,
    };

    return await httpClient.deleteAsync(request);
  }

  /**
   * Lấy dữ liệu kết chuyển xác định kết quả hoạt động
   * nmtuan4 2.9.2022
   * @param {*} param
   * @returns
   */
  getProfitLossTransferDefaultData(param) {
    let request = {
      url: this.getAPIUrl() + `/glProfitLossDefaultData`,
      data: param,
    };

    return httpClient.postAsync(request, true);
  }

  /**
   * Sinh dữ liệu chuyển khoản kho bạc từ Rút dụ toán chuyển khoản
   * NNLINH 03.11.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu theo relation_ref_id
   * @param {*} payload
   * @returns
   */
  getDataByRelationRefId(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataByRelationRefId',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new GLVoucherAPI();
